<ng-template #popoverTemplate>
    <div
        class="sb-popover-container"
        tabindex="-1"
        [style.width.px]="maxWidth"
        [ngClass]="activePosition"
        (click)="$event.stopPropagation()">
        <div
            class="sb-popover"
            #popover
            [ngStyle]="arrowStyles"
            [class.sb-popover-no-title]="!title.textContent">
            <div
                class="sb-popover-header-wrapper"
                [class.sb-popover-no-title-header]="!title.textContent">
                <h6 #title [hidden]="!title.textContent">
                    <ng-content select="[title]"></ng-content>
                </h6>

                <lib-icon-button
                    [icon]="Icon.Common.Close"
                    [kind]="ButtonKind.NeutralTertiary"
                    [size]="ButtonSize.Small"
                    (clicked)="Close()"></lib-icon-button>
            </div>
            <div
                class="sb-popover-content-wrapper"
                [class.sb-popover-no-title]="!title.textContent">
                <small>
                    <ng-content select="[content]"></ng-content>
                </small>
            </div>

            <div
                [hidden]="!actionBar.textContent"
                #actionBar
                class="sb-popover-actions-wrapper">
                <div class="sb-popover-secondary-button">
                    <ng-content select="[secondaryButton]"></ng-content>
                </div>
                <div class="sb-popover-primary-button">
                    <ng-content select="[primaryButton]"></ng-content>
                </div>
            </div>
        </div>
    </div>
</ng-template>
